import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { connect } from 'react-redux';
import { injectIntl } from '../Intl';
import setPrerenderReady from '../services/utils/setPrerenderReady';

import { Button } from '@s7/ui-kit';
import '../assets/styles/pages/NotFound.scss';



const NotFound = ({ deviceWidth, words, getMessage }) => {

    useEffect(() => {
        setPrerenderReady();
    }, []);

    const Graphic404 = <div className='notfound-404'>
        {number4Icon}
        <div className='img-container'>
            <img src='/S7PCabinService/media/by-path/raw/images/pages/404/illum.png' alt=''/>
        </div>
        {number4Icon}
    </div>

    return (
        <>
            <Helmet>
                <meta name='prerender-status-code' content='404'/>
                <title>S7 Airlines | 404 error page</title>
            </Helmet>
            <main className='notfound'>
                <div className='notfound-container'>
                    <div className='notfound-content'>
                        {(deviceWidth < 768) && Graphic404}
                        <h1 dangerouslySetInnerHTML={{
                            __html: getMessage(words, 'com.s7.404', 'header.h2'),
                        }}/>
                        <p className='text-regular'>
                            {getMessage(words, 'com.s7.404', 'info.text1')}
                            {getMessage(words, 'com.s7.404', 'info.text2')}
                        </p>
                        {(deviceWidth > 767) && Graphic404}
                        <div className='notfound-button'>
                            <Button
                                onClick={() => location.href = '/'}
                                theme='b2cGradient'
                                size='large'
                                >
                                {getMessage(words, 'com.s7.404', 'go.to.main')}
                            </Button>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
}

const number4Icon = <div className='svg-container'><svg width='170' height='230' viewBox='0 0 170 230' fill='none'>
    <path d='M96.7354 230.819V181.756H0.5856V142.572L110.894 0.981108H140.859V142.242H169.836V181.756H140.859V230.819H96.7354ZM44.7091 142.242H101.675V67.825L44.7091 142.242Z' fill='#FFF'/>
</svg></div>

const mapStateToProps = state => {
    return {
        lang: state.App.lang,
        deviceWidth: state.App.deviceWidth,
    }
};

export default injectIntl(connect(mapStateToProps)(React.memo(NotFound)));
